module.exports = __webpack_public_path__ + "static/media/nft-upload.a7bbcfd5.png";